import { ChevronLeft } from '@mui/icons-material';
import { IconButton } from '@mui/material';
import { useNavigate } from 'react-router-dom';

export default function NavigateBackButton({ route }) {
  const navigate = useNavigate();

  return (
    <IconButton
      onClick={() => navigate(route)}
      size="small"
      sx={{ color: '#0c0b0c' }}>
      <ChevronLeft sx={{ fontSize: "20px" }} />
    </IconButton>
  );
}
